import { useGLTF } from '@react-three/drei';
import PropTypes from 'prop-types';

function SedeMallPlaza({ status }) {
  const { nodes, materials } = useGLTF('/models/SedeMallPlaza.gltf');
  const colorInactive = 'Grey';
  return (
    <group dispose={null} position={[19, -4.8, 21]}>
      <mesh geometry={nodes.Cubo064.geometry} material={materials['nude build']} position={[-0.05, 6.22, 0.13]} material-color={status === false ? colorInactive : null} />
      <mesh
        geometry={nodes.Cubo011.geometry}
        material={materials.grey}
        position={[0.02, 1.49, -3.22]}
        rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
        material-color={status === false ? colorInactive : null}
      />
      <mesh geometry={nodes.Cubo017.geometry} material={materials['green glass']} position={[3.21, 12.12, -2.12]} rotation={[0, -0.04, Math.PI / 2]} material-color={status === false ? colorInactive : null} />
      <mesh geometry={nodes.Cubo018.geometry} material={materials['nude column']} position={[3.18, 7.01, -1.19]} rotation={[0, -0.04, Math.PI / 2]} material-color={status === false ? colorInactive : null} />
    </group>
  );
}

useGLTF.preload('/models/SedeMallPlaza.gltf');

export default SedeMallPlaza;

SedeMallPlaza.propTypes = {
  status: PropTypes.bool,
};

SedeMallPlaza.defaultProps = {
  status: true,
};
